export function showFeatureDeleteConfirmationModal(featureId){
    this.delete_feature_id = featureId;
    this.delete_feature_form.showModal = true;
}

export function showEditFeatureForm(featureType, featureId){
    if(featureType.length){
        this.current_edit_feature_id = featureId;
        this.current_feature_edit_box = featureType;
    } else {
        this.current_edit_feature_id = null;
        this.current_feature_edit_box = null;
    }
}

export function closeEditFeatureModal(){
    this.current_edit_feature_id = null;
    this.current_feature_edit_box = null;
}